import { t as __t } from "i18next";
import React, { useEffect, useState } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import BackPrevious from "../../../components/back-previous";
import SwalAlert from "../../../components/common/alert";
import SmartTable from "../../../components/common/table-component";
import ImageGallery from "../../../components/image-view";
import FileUploadGrid from "../../../components/upload-file";

import { callUploadFile } from "../../../api/settings/service";
import { callGetLifeInsuranceClaiming } from "../../../api/insurances/service";

import {
	approveClameLifeContract,
	callGetApproveContract,
} from "../../../api/contract/service";

import { callExportClamePDF } from "../../../api/export";

import {
	decodeBase64,
	FormatCurrencys,
	dateToString,
	calculateAgeByDate,
	convertStringToJson,
} from "../../../utils/commonUtil";

import "../../../components/i18n/lang";
import "./approve.css";
import { Modal } from "bootstrap";
import { DocumentPreviewUI } from "../../../components/document-preview";

const Index = () => {
	const [paymentPage, setPaymentPage] = useState(1);
	const [paymentPageSize, setPaymentPageSize] = useState(10);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const params = useParams();
	const { t } = useTranslation();

	const userInfo = useSelector((state) => state.dataLogin);

	const [id, setId] = useState(null);
	const [view, setView] = useState(false);
	const [tracking, setTracking] = useState(false);

	const [contract, setContract] = useState(null);
	const [clame, setClame] = useState(null);

	const [loading, setLoading] = useState(true);
	const [submitting, setSubmitting] = useState(false);
	const [downloading, setDownloading] = useState(false);

	const [request, setRequest] = useState({
		file: null,
	});

	useEffect(() => {
		initializePage();
	}, [params?.id]);

	const initializePage = async () => {
		if (!params?.id) {
			setLoading(false);
			return;
		}

		try {
			const decodedValue = decodeBase64(params.id);
			const data = JSON.parse(decodedValue);

			const isTracking = Boolean(data?.tracking);
			const requestId = data?.requestId || data?.id || null;

			setTracking(isTracking);
			setView(Boolean(data?.view) || isTracking);

			if (requestId) {
				setId(requestId);
				await loadData(requestId);
				return;
			}

			if (data?.contractNumber) {
				await loadDataByContractNumber(data.contractNumber);
				return;
			}

			setLoading(false);
		} catch (error) {
			console.error("Decode parameter error:", error);
			setLoading(false);

			SwalAlert.error(
				__t("uiText.text023"),
				__t("uiText.text026")
			);
		}
	};

	const loadDataByContractNumber = async (contractNumber) => {
		try {
			setLoading(true);

			const rsp = await dispatch(
				callGetLifeInsuranceClaiming({
					page: 1,
					maxResult: 20,
					contractNumber,
					status: "",
				})
			);

			if (rsp?.payload?.responseCode !== "00000") {
				SwalAlert.error(
					__t("uiText.text027"),
					rsp?.payload?.responseDescription || __t("uiText.text028")
				);
				setLoading(false);
				return;
			}

			const result = rsp?.payload?.data?.result;
			const claimList = Array.isArray(result) ? result : [];
			const claimItem =
				claimList.find((item) => item?.contractNumber === contractNumber) ||
				claimList[0];

			if (!claimItem?.id) {
				setLoading(false);
				SwalAlert.error(
					__t("uiText.text029"),
					__t("uiText.text030")
				);
				return;
			}

			setId(claimItem.id);
			await loadData(claimItem.id);
		} catch (error) {
			console.error("Resolve claim by contract error:", error);
			setLoading(false);
			SwalAlert.error(
				__t("uiText.text023"),
				__t("uiText.text031")
			);
		}
	};

	const safeJsonArray = (value) => {
		if (!value) return [];

		if (Array.isArray(value)) {
			return value;
		}

		try {
			const result = convertStringToJson(value);
			return Array.isArray(result) ? result : [];
		} catch (error) {
			console.error("Parse JSON error:", error);
			return [];
		}
	};

	const displayValue = (value, fallback = "-") => {
		if (
			value === null ||
			value === undefined ||
			value === ""
		) {
			return fallback;
		}

		return value;
	};

	const formatMoney = (value) => {
		return FormatCurrencys(Number(value || 0));
	};

	const loadData = async (requestId) => {
		try {
			setLoading(true);

			const rsp = await dispatch(
				callGetApproveContract({
					requestId,
				})
			);

			if (rsp?.payload?.responseCode !== "00000") {
				SwalAlert.error(
					__t("uiText.text027"),
					`${rsp?.payload?.responseCode || ""} - ${rsp?.payload?.responseDescription ||
					__t("uiText.text032")
					}`
				);
				return;
			}

			const data = rsp?.payload?.data;

			setContract({
				...data?.contract,
				heir: Array.isArray(data?.contract?.heir)
					? data.contract.heir
					: [],
				paymentDetail: Array.isArray(
					data?.contract?.paymentDetail
				)
					? data.contract.paymentDetail
					: [],
			});

			setClame(data?.requestClaim || null);
		} catch (error) {
			console.error("Load life claim error:", error);

			SwalAlert.error(
				__t("uiText.text023"),
				__t("uiText.text024")
			);
		} finally {
			setLoading(false);
		}
	};

	const handleImageSelect = (files) => {
		if (files?.files?.[0]) {
			setRequest({
				file: {
					file: files,
				},
			});
			return;
		}

		setRequest({
			file: null,
		});
	};

	const handleSubmitApprove = (event) => {
		event.preventDefault();
		handleSave(2, "approve insurance");
	};

	const handleSave = async (status, description) => {
		// if (!request?.file?.file) {
		// 	SwalAlert.error(
		// 		"ຂໍ້ມູນບໍ່ຄົບ!",
		// 		"ກະລຸນາອັບໂຫຼດເອກະສານອະນຸມັດ"
		// 	);
		// 	return;
		// }

		SwalAlert.confirm(
			t("swal.title.approve"),
			t("swal.text.confirmApprove"),
			async () => {
				try {
					setSubmitting(true);

					const upload = await dispatch(
						callUploadFile(request.file.file)
					);

					if (upload?.payload?.responseCode !== "00000") {
						SwalAlert.error(
							__t("uiText.text033"),
							upload?.payload?.responseDescription ||
							t("uploadFile.heirs2")
						);
						return;
					}

					const approvedPath = JSON.stringify(
						upload?.payload?.data || []
					);

					const req = {
						approvedPath,
						id,
						status,
						description,
						modifiedCode:
							userInfo?.data?.user?.userId,
						modifiedName: [
							userInfo?.data?.user?.firstName,
							userInfo?.data?.user?.lastName,
						]
							.filter(Boolean)
							.join(" "),
					};

					const rsp = await dispatch(
						approveClameLifeContract(req)
					);

					if (rsp?.payload?.responseCode === "00000") {
						const myModal = document.getElementById("approvedPopupModal");
						const modal = Modal.getInstance(myModal);
						modal.hide();

						notifyListRefresh();
						navigate("/admin/approved/lifeInsurance");
						return;
					}

					SwalAlert.error(
						__t("uiText.text034"),
						`${rsp?.payload?.responseCode || ""} - ${rsp?.payload?.responseDescription || ""
						}`
					);
				} catch (error) {
					console.error("Approve life claim error:", error);

					SwalAlert.error(
						__t("uiText.text023"),
						__t("uiText.text024")
					);
				} finally {
					setSubmitting(false);
				}
			}
		);
	};

	const downloadPDF = async (requestId) => {
		if (!requestId) return;

		try {
			setDownloading(true);

			const response = await callExportClamePDF({
				requestId,
			});

			if (!response) {
				SwalAlert.error(
					__t("uiText.text035"),
					__t("uiText.text036")
				);
				return;
			}

			const url = URL.createObjectURL(response);
			const link = document.createElement("a");

			link.href = url;
			link.download = `life_claim_${moment().format(
				"YYYYMMDDHHmmss"
			)}.pdf`;

			document.body.appendChild(link);
			link.click();
			link.remove();

			URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Download PDF error:", error);

			SwalAlert.error(
				__t("uiText.text035"),
				__t("uiText.text037")
			);
		} finally {
			setDownloading(false);
		}
	};

	const paymentColumns = [
		{
			label: "paymentBillNumber",
			key: "contractNumber",
			style: {
				width: "180px",
			},
		},
		{
			label: "paymentPaidMonth",
			key: "paidMonth",
			style: {
				width: "100px",
			},
			render: (value, item) =>
				value
					? `${item.paidMonth}/${item.paidYear}`
					: "-",
		},
		{
			label: "paymentPayPerMonth",
			key: "payPerMonth",
			style: {
				width: "130px",
			},
			render: (value) =>
				value ? formatMoney(value) : "-",
		},
		{
			label: "paymentTotalDiscount",
			key: "totalDiscount",
			style: {
				width: "130px",
			},
			render: (value) =>
				value ? formatMoney(value) : "-",
		},
		{
			label: "paymentCommissionAmount",
			key: "commissionAmount",
			style: {
				width: "150px",
			},
			render: (value) =>
				value ? formatMoney(value) : "-",
		},
		{
			label: "paymentCompanyReceivedAmount",
			key: "companyReceivedAmount",
			style: {
				width: "180px",
			},
			render: (value) =>
				value ? formatMoney(value) : "-",
		},
	];
	const paymentList = Array.isArray(contract?.paymentDetail)
		? contract.paymentDetail
		: [];
	const paymentTotalRecords = paymentList.length;

	const paymentTotalPages = Math.max(
		1,
		Math.ceil(paymentTotalRecords / paymentPageSize)
	);

	const paymentStartIndex = (paymentPage - 1) * paymentPageSize;
	const paymentEndIndex = paymentStartIndex + paymentPageSize;

	const paymentPaginationData = paymentList.slice(
		paymentStartIndex,
		paymentEndIndex
	);

	const handlePaymentPageChange = (page) => {
		if (page < 1 || page > paymentTotalPages) return;

		setPaymentPage(page);
	};

	const handlePaymentPageSizeChange = (event) => {
		setPaymentPageSize(Number(event.target.value));
		setPaymentPage(1);
	};
	const PaymentPagination = ({
		currentPage,
		totalPages,
		totalRecords,
		pageSize,
		onPageChange,
	}) => {
		const startRecord =
			totalRecords === 0
				? 0
				: (currentPage - 1) * pageSize + 1;

		const endRecord = Math.min(
			currentPage * pageSize,
			totalRecords
		);

		const getPageNumbers = () => {
			const pages = [];
			const maxVisiblePages = 5;

			let startPage = Math.max(
				1,
				currentPage - Math.floor(maxVisiblePages / 2)
			);

			let endPage = startPage + maxVisiblePages - 1;

			if (endPage > totalPages) {
				endPage = totalPages;
				startPage = Math.max(
					1,
					endPage - maxVisiblePages + 1
				);
			}

			for (
				let page = startPage;
				page <= endPage;
				page++
			) {
				pages.push(page);
			}

			return pages;
		};

		const pages = getPageNumbers();



		return (
			<div className="payment-pagination-wrapper">
				<div className="payment-pagination-info">
					{__t("uiText.text038")}{startRecord} - {endRecord} {__t("uiText.text039")}{" "}
					{totalRecords} {__t("uiText.text040")}</div>

				<div className="payment-pagination">
					<button
						type="button"
						className="payment-page-button"
						disabled={currentPage === 1}
						onClick={() =>
							onPageChange(currentPage - 1)
						}
					>
						<i className="fas fa-chevron-left" />
					</button>

					{pages[0] > 1 && (
						<>
							<button
								type="button"
								className="payment-page-button"
								onClick={() => onPageChange(1)}
							>
								1
							</button>

							{pages[0] > 2 && (
								<span className="payment-page-dots">
									...
								</span>
							)}
						</>
					)}

					{pages.map((page) => (
						<button
							key={page}
							type="button"
							className={`payment-page-button ${page === currentPage
								? "active"
								: ""
								}`}
							onClick={() =>
								onPageChange(page)
							}
						>
							{page}
						</button>
					))}

					{pages[pages.length - 1] <
						totalPages && (
							<>
								{pages[pages.length - 1] <
									totalPages - 1 && (
										<span className="payment-page-dots">
											...
										</span>
									)}

								<button
									type="button"
									className="payment-page-button"
									onClick={() =>
										onPageChange(totalPages)
									}
								>
									{totalPages}
								</button>
							</>
						)}

					<button
						type="button"
						className="payment-page-button"
						disabled={
							currentPage === totalPages
						}
						onClick={() =>
							onPageChange(currentPage + 1)
						}
					>
						<i className="fas fa-chevron-right" />
					</button>
				</div>
			</div>
		);
	};

	return (
		<div className="page-wrapper dashboard life-claim-page">
			<span className="header-span" />

			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />

			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="life-claim-page-header">
						<div className="life-claim-heading">
							<BackPrevious />

							<div>
								<span className="life-claim-heading-label">
									{__t("uiText.text419")}</span>

								<h3>{tracking ? __t("uiText.text041") : t("contracts.clame")}</h3>

								<p>
									{tracking
										? __t("uiText.text042")
										: __t("uiText.text043")}
								</p>
							</div>
						</div>

						{contract && (
							<div
								className={`life-claim-view-badge ${view
									? "life-claim-view-only"
									: "life-claim-pending"
									}`}
							>
								<i
									className={
										view
											? "fas fa-eye"
											: "fas fa-clock"
									}
								/>

								{tracking
									? __t("uiText.text044")
									: view
										? __t("uiText.text045")
										: __t("uiText.text046")}
							</div>
						)}
					</div>

					{loading && (
						<div className="life-claim-loading">
							<div
								className="spinner-border text-primary"
								role="status"
							/>

							<span>{__t("uiText.text047")}</span>
						</div>
					)}

					{!loading && !contract && (
						<div className="life-claim-empty">
							<div className="life-claim-empty-icon">
								<i className="fas fa-folder-open" />
							</div>

							<h4>{__t("uiText.text048")}</h4>

							<p>
								{__t("uiText.text049")}</p>
						</div>
					)}

					{!loading && contract && clame && (
						<>
							{tracking && (
								<ClaimProgressTracker
									status={clame?.status}
									requestDate={clame?.carriredDate}
									approvedDate={clame?.updatedAt}
									description={clame?.descriptionUser || clame?.description}
								/>
							)}

							<div className="life-customer-card">
								<div className="life-customer-main">
									<div className="life-customer-avatar">
										{contract?.fullName
											?.charAt(0)
											?.toUpperCase() || "C"}
									</div>

									<div className="life-customer-content">
										<span className="life-customer-label">
											{__t("uiText.text050")}</span>

										<h4>
											{displayValue(
												contract.fullName
											)}
										</h4>

										<div className="life-customer-meta">
											<span>
												<i className="fas fa-phone" />
												{displayValue(
													contract.phone
												)}
											</span>

											<span>
												<i className="fas fa-map-marker-alt" />
												{displayValue(
													contract.address
												)}
											</span>

											<span>
												<i className="fas fa-user-tie" />
												{__t("uiText.text420")}{" "}
												{displayValue(
													contract.agentCode
												)}
											</span>
										</div>
									</div>
								</div>

								<div className="life-claim-actions">
									{!view && (
										<button
											type="button"
											className="life-action-btn life-action-primary"
											data-bs-toggle="modal"
											data-bs-target="#approvedPopupModal"
											onClick={() =>
												setRequest({
													file: null,
												})
											}
										>
											<i className="fas fa-check-circle" />
											{t("button.approveClame")}
										</button>
									)}

									<button
										type="button"
										className="life-action-btn life-action-outline"
										disabled={downloading}
										onClick={() =>
											downloadPDF(clame?.id)
										}
									>
										<i
											className={
												downloading
													? "fas fa-spinner fa-spin"
													: "fas fa-file-pdf"
											}
										/>

										{t(
											"button.clameDownloadPDF"
										)}
									</button>
								</div>
							</div>

							<div className="life-summary-grid">
								<SummaryCard
									icon="fa-hand-holding-usd"
									label={t(
										"contract.moneyReturn"
									)}
									value={`${formatMoney(
										clame?.claimAmount
									)} ${t("currentcy.kip")}`}
									type="blue"
								/>

								<SummaryCard
									icon="fa-money-check-alt"
									label={t(
										"contract.refundAfterFee"
									)}
									value={`${formatMoney(
										clame?.refundAfterFee
									)} ${t("currentcy.kip")}`}
									type="green"
								/>

								<SummaryCard
									icon="fa-calendar-check"
									label={t(
										"contract.totalPaidAmount"
									)}
									value={`${displayValue(
										clame?.totalPaidAmount,
										0
									)} ${t("title.month")}`}
									type="orange"
								/>

								<SummaryCard
									icon="fa-wallet"
									label={t(
										"contract.overPaidAmount"
									)}
									value={`${formatMoney(
										clame?.overPaidAmount
									)} ${t("currentcy.kip")}`}
									type="purple"
								/>
							</div>

							<div className="row g-4">
								<div className="col-xl-8 col-lg-7">
									<section className="life-card">
										<SectionHeader
											icon="fa-clipboard-list"
											title={t(
												"contract.clameInfo"
											)}
											description={__t("uiText.text051")}
										/>

										<div className="life-info-grid">
											<InfoBox
												icon="fa-file-medical"
												label={t(
													"contract.claimType"
												)}
												value={t(
													`causeList.${clame?.claimCause}`
												)}
											/>

											<InfoBox
												icon="fa-calendar-day"
												label={t(
													"contract.amountDay"
												)}
												value={displayValue(
													clame?.amountDay
												)}
											/>

											<InfoBox
												icon="fa-align-left"
												label={t(
													"contract.clameDescription"
												)}
												value={displayValue(
													clame?.description
												)}
												full
											/>
										</div>
									</section>

									<section className="life-card mt-4">
										<SectionHeader
											icon="fa-file-alt"
											title={__t("uiText.text052")}
											description={__t("uiText.text053")}
										/>

										<DocumentGroup
											title={t(
												"contract.docClame"
											)}
											icon="fa-file-medical-alt"
											paths={safeJsonArray(
												clame?.documentPath
											)}
										/>

										<DocumentGroup
											title={t(
												"contract.beneficiarClame"
											)}
											icon="fa-user-shield"
											paths={safeJsonArray(
												clame?.beneficiaryDocumentPath
											)}
										/>
									</section>

									<section className="life-card mt-4">
										<SectionHeader
											icon="fa-id-card"
											title={t(
												"contract.documentImage"
											)}
											description={__t("uiText.text054")}
										/>

										<div className="life-gallery-wrapper">
											{safeJsonArray(
												contract.documentImagePath
											).length > 0 ? (
												<ImageGallery
													paths={safeJsonArray(
														contract.documentImagePath
													)}
												/>
											) : (
												<EmptyDocument />
											)}
										</div>
									</section>

									<section className="life-card mt-4">
										<SectionHeader
											icon="fa-users"
											title={t("contract.heir")}
											description={__t("uiText.text055")}
										/>

										<div className="life-heir-list">
											{contract?.heir?.length >
												0 ? (
												contract.heir.map(
													(
														item,
														index
													) => (
														<HeirCard
															key={
																item?.id ||
																index
															}
															item={
																item
															}
															index={
																index
															}
															t={t}
															paths={safeJsonArray(
																item?.documentImagePath
															)}
														/>
													)
												)
											) : (
												<div className="life-empty-small">
													<i className="fas fa-user-slash" />
													<span>
														{__t("uiText.text056")}</span>
												</div>
											)}
										</div>
									</section>

									<section className="life-card mt-4">
										<SectionHeader
											icon="fa-receipt"
											title={t(
												"contract.paymentDetail"
											)}
											description={t("uiLabels.paymentHistory")}
										/>

										<div className="life-table-wrapper">
											<div className="payment-table-toolbar">
												<div className="payment-table-summary">
													<span>{t("uiLabels.totalItems")}</span>

													<strong>
														{paymentTotalRecords}
													</strong>

													<span>{t("uiLabels.items")}</span>
												</div>

												<div className="payment-page-size">
													<label htmlFor="paymentPageSize">
														{t("uiLabels.showColon")}
													</label>

													<select
														id="paymentPageSize"
														value={paymentPageSize}
														onChange={handlePaymentPageSizeChange}
													>
														<option value={5}>5</option>
														<option value={10}>10</option>
														<option value={20}>20</option>
														<option value={50}>50</option>
													</select>

													<span>{t("uiLabels.items")}</span>
												</div>
											</div>

											<SmartTable
												columns={paymentColumns}
												data={{
													result: paymentPaginationData,
												}}
												recordsTableFilter={false}
												customPagination={false}
											/>

											{paymentTotalRecords > 0 && (
												<PaymentPagination
													currentPage={paymentPage}
													totalPages={paymentTotalPages}
													totalRecords={paymentTotalRecords}
													pageSize={paymentPageSize}
													onPageChange={handlePaymentPageChange}
												/>
											)}
										</div>
									</section>
								</div>

								<div className="col-xl-4 col-lg-5">
									<section className="life-card life-sticky-card">
										<SectionHeader
											icon="fa-file-contract"
											title={__t("uiText.text057")}
											description={__t("uiText.text058")}
										/>

										<div className="life-contract-highlight">
											<div className="life-contract-icon">
												<i className="fas fa-shield-alt" />
											</div>

											<div>
												<span>
													{t(
														"contract.contractNumber"
													)}
												</span>

												<strong>
													{displayValue(
														contract.contractNumber
													)}
												</strong>
											</div>
										</div>

										<DetailRow
											label={t(
												"contract.package"
											)}
											value={`${displayValue(
												contract.ageRange
											)} ${t(
												"title.year"
											)}`}
										/>

										<DetailRow
											label={t("uiLabels.monthlyPremium")}
											value={`${formatMoney(
												contract.payPerMonth
											)} ${t(
												"currentcy.kip"
											)}`}
										/>

										<DetailRow
											label={t(
												"contract.dateOfBirth"
											)}
											value={
												contract.dateOfBirth
													? dateToString(
														contract.dateOfBirth,
														"DD/MM/YYYY"
													)
													: "-"
											}
										/>

										<DetailRow
											label={t(
												"contract.age"
											)}
											value={`${calculateAgeByDate(
												contract.dateOfBirth,
												contract.signedDate
											)} ${t(
												"title.year"
											)}`}
										/>

										<DetailRow
											label={t(
												"contract.signDate"
											)}
											value={
												contract.signedDate
													? dateToString(
														contract.signedDate,
														"DD/MM/YYYY"
													)
													: "-"
											}
										/>

										<DetailRow
											label={t(
												"contract.lastPayDate"
											)}
											value={
												contract.lastPay ||
												t("noPay")
											}
										/>

										<DetailRow
											label={t(
												"contract.totalPayMonth"
											)}
											value={`${displayValue(
												contract.totalPayMonth,
												0
											)} ${t(
												"title.month"
											)}`}
										/>

										<DetailRow
											label={t(
												"contract.gender.label"
											)}
											value={
												contract.gender !==
													null &&
													contract.gender !==
													undefined
													? t(
														`contract.gender.${contract.gender}`
													)
													: "-"
											}
										/>
									</section>

									<section className="life-card mt-4">
										<SectionHeader
											icon="fa-id-badge"
											title={__t("uiText.text059")}
											description={__t("uiText.text060")}
										/>

										<DetailRow
											label={t(
												`contract.docType.${contract.documentTypeId}`
											)}
											value={
												contract.documentNo
											}
										/>

										<DetailRow
											label={t(
												"contract.homeNumber"
											)}
											value={
												contract.homeNumber
											}
										/>

										<DetailRow
											label={t(
												"contract.unitNumber"
											)}
											value={
												contract.unitNumber
											}
										/>
									</section>

									<section className="life-card mt-4">
										<SectionHeader
											icon="fa-university"
											title={__t("uiText.text061")}
											description={__t("uiText.text062")}
										/>

										<div className="life-bank-box">
											<div className="life-bank-logo">
												<i className="fas fa-university" />
											</div>

											<div>
												<span>
													{t(
														"contract.bank"
													)}
												</span>

												<strong>
													{clame?.bankType
														? t(
															`bank.${clame.bankType}`
														)
														: "-"}
												</strong>
											</div>
										</div>

										<DetailRow
											label={t(
												"contract.bankName"
											)}
											value={
												clame?.bankAccName
											}
										/>

										<DetailRow
											label={t(
												"contract.bankAcc"
											)}
											value={clame?.bankAcc}
											highlight
										/>
									</section>
								</div>
							</div>
						</>
					)}
				</div>
			</section>

			<CopyrightFooter />

			<div
				className="modal fade"
				id="approvedPopupModal"
				tabIndex="-1"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
					<div className="modal-content life-approve-modal">
						<div className="life-modal-header">
							<div className="life-modal-title">
								<div className="life-modal-icon">
									<i className="fas fa-check-circle" />
								</div>

								<div>
									<h3>
										{t(
											"contract.approvedForm"
										)}
									</h3>

									<p>
										{__t("uiText.text063")}</p>
								</div>
							</div>

							<button
								type="button"
								className="life-modal-close"
								data-bs-dismiss="modal"
								aria-label={t("accessibility.close")}
							>
								<i className="fas fa-times" />
							</button>
						</div>

						<form onSubmit={handleSubmitApprove}>
							<div className="modal-body life-modal-body">
								<div className="life-upload-heading">
									<div>
										<label>
											{t("contract.file")}
											<span className="text-danger">
												*
											</span>
										</label>

										<p>
											{__t("uiText.text064")}</p>
									</div>

									{request?.file && (
										<span className="life-file-selected">
											<i className="fas fa-check" />
											{__t("uiText.text065")}</span>
									)}
								</div>

								<div className="life-upload-box">
									<FileUploadGrid
										multiple={false}
										folderName="clameLife"
										onChange={handleImageSelect}
										accept="image/*,application/pdf"
										required
									/>
								</div>

								<div className="life-modal-warning">
									<i className="fas fa-info-circle" />

									<span>
										{__t("uiText.text066")}</span>
								</div>
							</div>

							<div className="life-modal-footer">
								<button
									type="button"
									className="life-action-btn life-action-cancel"
									data-bs-dismiss="modal"
									disabled={submitting}
								>
									<i className="fas fa-times" />
									{__t("uiText.text067")}</button>

								<button
									type="submit"
									className="life-action-btn life-action-primary"
									disabled={submitting}
								>
									<i
										className={
											submitting
												? "fas fa-spinner fa-spin"
												: "fas fa-check"
										}
									/>

									{submitting
										? __t("uiText.text068")
										: t("button.save")}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

const ClaimProgressTracker = ({
	status,
	requestDate,
	approvedDate,
	description,
}) => {
	const numericStatus = Number(status);
	const rejected = numericStatus === 0;
	const currentStep = numericStatus === 3 ? 4 : numericStatus === 2 ? 3 : 2;

	const steps = [
		{ id: 1, title: __t("uiText.text069"), description: requestDate ? __t("uiText.text070", { value1: dateToString(requestDate, "DD/MM/YYYY") }) : __t("uiText.text071"), icon: "fa-file-signature" },
		{ id: 2, title: rejected ? __t("uiText.text072") : __t("uiText.text073"), description: rejected ? (description || __t("uiText.text074")) : numericStatus === 1 ? __t("uiText.text075") : __t("uiText.text076"), icon: rejected ? "fa-times-circle" : "fa-search" },
		{ id: 3, title: __t("uiText.text077"), description: numericStatus >= 2 ? (approvedDate ? __t("uiText.text078", { value1: dateToString(approvedDate, "DD/MM/YYYY") }) : __t("uiText.text079")) : __t("uiText.text080"), icon: "fa-check-circle" },
		{ id: 4, title: __t("uiText.text081"), description: numericStatus === 3 ? __t("uiText.text082") : __t("uiText.text083"), icon: "fa-wallet" },
	];

	return (
		<section className={`claim-progress-card ${rejected ? "claim-progress-rejected" : ""}`}>
			<div className="claim-progress-header">
				<div>
					<span className="claim-progress-kicker">{__t("uiText.text421")}</span>
					<h4>{__t("uiText.text084")}</h4>
					<p>{__t("uiText.text085")}</p>
				</div>
				<span className={`claim-progress-status status-${numericStatus}`}>
					{numericStatus === 0 ? __t("uiText.text086") : numericStatus === 1 ? __t("uiText.text087") : numericStatus === 2 ? __t("uiText.text088") : numericStatus === 3 ? __t("uiText.text081") : __t("uiText.text089")}
				</span>
			</div>

			<div className="claim-progress-steps">
				{steps.map((step) => {
					const isCompleted = rejected ? step.id === 1 : step.id < currentStep;
					const isCurrent = rejected ? step.id === 2 : step.id === currentStep;
					const isRejectedStep = rejected && step.id === 2;
					return (
						<div key={step.id} className={`claim-progress-step ${isCompleted ? "completed" : ""} ${isCurrent ? "current" : ""} ${isRejectedStep ? "rejected" : ""}`}>
							<div className="claim-progress-icon"><i className={`fas ${isCompleted ? "fa-check" : step.icon}`} /></div>
							<div className="claim-progress-copy"><span>{__t("uiText.text090")}{step.id}</span><strong>{step.title}</strong><p>{step.description}</p></div>
						</div>
					);
				})}
			</div>
		</section>
	);
};

const SummaryCard = ({
	icon,
	label,
	value,
	type,
}) => {
	return (
		<div
			className={`life-summary-card life-summary-${type}`}
		>
			<div className="life-summary-icon">
				<i className={`fas ${icon}`} />
			</div>

			<div>
				<span>{label}</span>
				<strong>{value}</strong>
			</div>
		</div>
	);
};

const SectionHeader = ({
	icon,
	title,
	description,
}) => {
	return (
		<div className="life-section-header">
			<div className="life-section-header-icon">
				<i className={`fas ${icon}`} />
			</div>

			<div>
				<h4>{title}</h4>
				<p>{description}</p>
			</div>
		</div>
	);
};

const InfoBox = ({
	icon,
	label,
	value,
	full = false,
}) => {
	return (
		<div
			className={`life-info-box ${full ? "life-info-full" : ""
				}`}
		>
			<div className="life-info-icon">
				<i className={`fas ${icon}`} />
			</div>

			<div>
				<span>{label}</span>
				<strong>{value || "-"}</strong>
			</div>
		</div>
	);
};

const DetailRow = ({
	label,
	value,
	highlight = false,
}) => {
	return (
		<div className="life-detail-row">
			<span>{label}</span>

			<strong
				className={
					highlight ? "life-detail-highlight" : ""
				}
			>
				{value || "-"}
			</strong>
		</div>
	);
};

const DocumentGroup = ({
	title,
	icon,
	paths,
}) => {
	return (
		<div className="life-document-group">
			<div className="life-document-group-title">
				<div className="life-document-group-icon">
					<i className={`fas ${icon}`} />
				</div>

				<div>
					<strong>{title}</strong>
					<span>
						{paths?.length || 0} {__t("uiText.text091")}</span>
				</div>
			</div>

			{paths?.length > 0 ? (
				<div className="life-document-items">
					<DocumentPreviewUI documents={paths} variant="cell" />
				</div>
			) : (
				<div className="life-document-empty">
					<i className="far fa-file" />
					{__t("uiText.text092")}</div>
			)}
		</div>
	);
};

const EmptyDocument = () => {
	return (
		<div className="life-empty-small">
			<i className="far fa-images" />
			<span>{__t("uiText.text093")}</span>
		</div>
	);
};

const HeirCard = ({
	item,
	index,
	t,
	paths,
}) => {
	return (
		<article className="life-heir-card">
			<div className="life-heir-header">
				<div className="life-heir-number">
					{index + 1}
				</div>

				<div className="life-heir-title">
					<span>
						{t(
							`contract.heirs.${index + 1}`
						)}
					</span>

					<h5>
						{[item?.firstName, item?.lastName]
							.filter(Boolean)
							.join(" ") || "-"}
					</h5>
				</div>

				<div className="life-heir-relation">
					{item?.relation !== undefined &&
						item?.relation !== null
						? t(
							`contract.relation.${item.relation}`
						)
						: "-"}
				</div>
			</div>

			<div className="life-heir-body">
				<div className="life-heir-details">
					<DetailRow
						label={t("contract.address")}
						value={item?.address}
					/>

					<DetailRow
						label={t(
							`contract.docType.${item?.documentTypeId}`
						)}
						value={item?.documentNo}
					/>

					<DetailRow
						label={t(
							"contract.homeNumber"
						)}
						value={item?.homeNumber}
					/>

					<DetailRow
						label={t(
							"contract.unitNumber"
						)}
						value={item?.unitNumber}
					/>

					<DetailRow
						label={t("contract.age")}
						value={item?.age}
					/>

					<DetailRow
						label={t("contract.phone")}
						value={item?.phone}
					/>
				</div>

				<div className="life-heir-images">
					{paths?.length > 0 ? (
						<ImageGallery paths={paths} />
					) : (
						<EmptyDocument />
					)}
				</div>
			</div>
		</article>
	);
};

export default Index;